import { hero } from "../../../mocks/portalData";

export default function HeroHeadline() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative mx-auto mt-5 w-full max-w-[1320px] px-4 md:mt-7 md:px-6">
        <div className="relative h-[420px] w-full overflow-hidden rounded-xl md:h-[600px]">
          <img
            src={hero.image}
            alt={hero.title}
            title="52黑料 头版头条"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/35 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-10">
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="flex items-center gap-2">
                <span className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill text-sm"></i>
                  {hero.kicker}
                </span>
                <span className="whitespace-nowrap rounded-md border border-background-50/25 bg-foreground-950/30 px-2.5 py-1 text-xs font-medium text-background-50">
                  {hero.heat}
                </span>
              </div>
              <h2 className="max-w-3xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
                {hero.title}
              </h2>
              <p className="max-w-2xl text-sm leading-relaxed text-background-50/80 md:text-base">{hero.summary}</p>
              <div className="flex flex-wrap items-center gap-2">
                {hero.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-full border border-background-50/20 px-3 py-1 text-xs font-medium text-background-50"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center">
                <div className="flex flex-wrap items-center gap-2 sm:flex-row">
                  <button
                    type="button"
                    className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-bold text-foreground-950 hover:bg-background-200"
                  >
                    展开完整时间线
                    <i className="ri-arrow-right-line text-sm"></i>
                  </button>
                  <button
                    type="button"
                    className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 text-sm font-bold text-background-50 hover:bg-background-50/10"
                  >
                    <i className="ri-bookmark-line text-sm"></i>
                    收藏图鉴
                  </button>
                </div>
                <span className="flex items-center gap-1.5 text-xs text-background-50/70">
                  <i className="ri-time-line"></i>
                  {hero.reading}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}